import { QueryResult } from '@apollo/client'
import { GetNonUserEmailsQuery, useGetNonUserEmailsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

type GetNonUserEmailsQueryResult = QueryResult<GetNonUserEmailsQuery>
export type NonUserEmail = GetNonUserEmailsQuery['nonUserEmails']['records'][0]

const { Provider, useContextFn } = createStrictContext<{
  records: NonUserEmail[]
  refetch: GetNonUserEmailsQueryResult['refetch']
  fetching: GetNonUserEmailsQueryResult['loading']
}>('NonUserEmailsTableContext')

export const useNonUserEmailsTableContext = useContextFn

export const NonUserEmailsTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetNonUserEmailsQuery({
    ...DefaultQueryHookOptions,
    variables: { input: { projectId: { equals: projectId } } },
  })
  return (
    <Provider
      value={{
        records: data?.nonUserEmails?.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
